module.exports = __webpack_public_path__ + "assets/img/wxewm.c0817ba9.png";